<template>
  <v-app>
    <app-navigation></app-navigation>
    <v-content transition="slide-x-transition">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import AppNavigation from '@/components/AppNavigation';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    AppNavigation
  },
  created() {
    //console.log('Created app: ', this);

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', event => {
        console.warn('Received Message from Service Worker: ', event.data);
        if ('firebase-messaging-msg-data' in event.data) {
          let data = event.data['firebase-messaging-msg-data'];
          //console.warn('Received message from service worker: ', data);
          //this.$store.commit('signalling/incomingPush', event.data);
          let content = null;
          if ('data' in data && 'default' in data.data) {
            content = JSON.parse(data.data.default);
          }
          if ('data' in data && 'message' in data.data) {
            content = JSON.parse(data.data.message);
          }
          if (content) {
            if ('Event' in content) {
              switch (content.Event) {
                case 'ring':
                  let url = new URL('/handle', self.location.origin);
                  let params = {};
                  for (let key in content) {
                    console.log(key);
                    //let value = event.notification.data[key];
                    params[key] = content[key];
                  }
                  console.log('Target url now is ', url);
                  this.$router.push({ path: url.pathname, query: params });
                  break;
                case 'missed':
                  break;
              }
            }
          }
        }
      });
    }
  },
  computed: {
    haveToken() {
      return this.auth_token && this.messaging_token;
    },
    ...mapState('signalling', ['auth_token', 'messaging_token'])
  }
};
</script>
